<template>
    <div class="home-wrap">
			<div class="top">
				<div class="banner">
					<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
						<van-swipe-item>
							<img src="../assets/banner-1.png" />
						</van-swipe-item>
						<van-swipe-item>
							<img src="../assets/banner-1.png" />
						</van-swipe-item>
						<van-swipe-item>
							<img src="../assets/banner-1.png" />
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="card">
					<div class="head">
						<div class="avator">
							<img :src="userInfo.avatar"/>
						</div>
						<div class="name">{{userInfo.userName}}</div>
						<el-popover
						  placement="bottom"
						  width="300"
						  trigger="click">
							<img :src="userInfo.qcCode" class="qrcode" />
						  <img slot="reference" src="../assets/qrcode.png" class="qrcode" />
						</el-popover>
						<img v-if="userInfo.checkStatus" @click="msgVisible = true" src="../assets/message-icon-1.png" class="message" />
						<img v-else @click="msgVisible = true" src="../assets/message-icon.png" class="message" />
					</div>
					<div class="cont">{{userInfo.school}} {{userInfo.gradeClass}}</div>
					<div class="btn-group">
						<img src="../assets/game-icon-act.png" v-if="isGame" @click="goGame" class="game gameact" />
						<img src="../assets/game-icon.png" v-else class="game" />
						<div class="clockin" @click="getClockOpera(userInfo.clockStatus)" :class="userInfo.clockStatus?'isClock':''">打卡</div>
					</div>
				</div>
			</div>
			<div class="subject">
				<div class="tab actTab" @click="goShiting">体验课</div>
				<div class="tab" v-for="(item,index) in tabList" :key="index" :class="actTab==item.id?'actTab':''" @click="getSubject(item.id)">{{item.name}}</div>
			</div>
			<div class="main">
				<div class="course-list">
					<div class="sub-head">
						<div class="course-title">课程列表</div>
						<div class="course-more" @click="moreCourse">查看全部
							<img src="../assets/icon／arrow-right@2x.png">
						</div>
					</div>
					<div class="course-cont">
						<div class="course-card" @click="goCourse(item)" v-for="(item,index) in courseList" v-if="index<6" :key="index">
							<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
								<!-- <div v-if="item.isComplete" class="course-study course-study-end">已完成</div>
								<div v-else-if="item.isContinue" class="course-study">继续学习</div> -->
								<img v-if="item.ruo" class="course-ruo" src="../assets/ruo-icon.png" alt="" />
							</div>
							<div class="course-name">{{item.point_name}}</div>
							<div class="course-text">{{item.point_info}}</div>
							<div class="course-btn">
								<!-- <img class="course-avator" :src="item.avator" alt="" /> -->
								<div v-if="item.isCollect" class="course-save course-save-act" @click.stop="collect(item)"></div>
								<div v-else class="course-save" @click.stop="collect(item)"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="exam-list">
						<div class="sub-head">
							<div class="course-title">考试</div>
							<div class="course-more" @click="moreExam">查看全部
								<img src="../assets/icon／arrow-right@2x.png">
							</div>
						</div>
						<div class="exam-item" v-for="(item,index) in examList" :key="index">
							<div class="exam-name">{{item.title}}</div>
							<div class="exam-time">
								<div v-if="item.end_time" @click="goExam(item,1)" class="btn">
									<div class="test-list-icon reading-icon"></div>
									重新考试</div>
								<div v-if="item.end_time" @click="goExam(item)" class="btn">
									<div class="test-list-icon reading-icon"></div>
									查看试卷</div>
								<div v-if="!item.end_time" @click="goExam(item)" class="btn btn-ok">
									<div class="test-list-icon reading-icon-no"></div>
									开始考试</div>
								<!-- <img v-if="!isDone(item.url)" src="../assets/icon／arrow-right@2x.png"> -->
							</div>
						</div>
					</div>
					<div class="ruo-list">
						<div class="sub-head">
							<div class="course-title">弱点清单</div>
						</div>
						<div class="ruo-item" v-for="(item,index) in ruoList" :key="index">
							<div class="ruo-name">{{item.pointName}}</div>
							<div class="ruo-btn" @click="goCourse(item, true)" >
						<img src="../assets/course.png">课程
						<span v-if="!item.courseStatus">（{{item.courseCompleteQty}}/{{item.courseTotalQty}}）</span>
						<span style="margin:0 4px" v-else>已完成</span>
					</div>
							<div class="ruo-btn" @click="goTest(item)">
								<img src="../assets/test.png">练习
								<span v-if="!item.practiseStatus">（{{item.practiseCompleteQty}}/{{item.practiseTotalQty}}）</span>
								<span style="margin:0 4px" v-else>已完成</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog title="联系老师" width="800px" :visible.sync="msgVisible">
				<div class="msg-wrap">
					<div class="teacher-cont">
						<div class="teacher-item" :class="receiverId==-1?'teacher-item-act':''" @click="getNoticeList()">
							<div class="teacher">系统公告</div>
						</div>
						<div class="teacher-item" :class="item.code == receiverId?'teacher-item-act':''" v-for="(item,index) in teacherList" @click="getMessageList(item.code)" :key="index">
							<div class="teacher">{{item.name}}</div>
							<div class="new" v-if="item.checkStatus">新!</div>
						</div>
					</div>
					<div class="msg-cont" ref="scrollContainer">
						<div class="msg-item" :class="!item.isSend?'msg-teacher':'msg-student'" v-for="(item,index) in msgList" :key="index">
							<div v-if="receiverId!=-1" class="avator" :style="item.isSend ? { backgroundImage: `url(${userInfo.avatar})` } : {}"></div>
							<div v-else class="avator sys-avator"></div>
							<div>
								<div v-if="item.url" class="media-message">
									<!-- 判断文件类型并显示 -->
									<template v-if="isFileType(item.url, 'pdf')">
										<!-- PDF 预览链接 -->
										<div style="cursor: pointer;color: blue;text-decoration: underline;" @click="showPdf(item.url)">查看PDF文件</div>
									</template>
									<template v-else-if="isFileType(item.url, 'img')">
										<!-- 图片显示 -->
										<img class="media-item" :src="item.url" alt="图片消息" />
									</template>
									<template v-else-if="isFileType(item.url, 'video')">
										<!-- 视频显示 -->
										<video class="media-item" controls>
											<source :src="item.url" type="video/mp4" />
											您的浏览器不支持Video标签。
										</video>
									</template>
									<template v-else-if="isFileType(item.url, 'audio')">
										<!-- 音频显示 -->
										<audio class="media-item" controls>
											<source :src="item.url" type="audio/mpeg" />
											您的浏览器不支持Audio标签。
										</audio>
									</template>
									<template v-else>
										<!-- 其他文件类型，显示下载链接 -->
										[不支持的文件类型]
									</template>
								</div>
								<div v-else class="message">{{item.content}}</div>
								<div class="timestamp">{{item.timestamp}}</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-input v-if="receiverId!=-1" type="textarea" maxlength="500" show-word-limit :rows="2" class="msgText" v-model="msgText" placeholder="输入回复内容" />
					<el-button v-if="receiverId!=-1" type="primary" class="enter" @click="getMessageAdd">发送</el-button>
				</div>
			</el-dialog>
			<el-dialog title="预览" width="1000px" :visible.sync="pdfVisible">
				<div class="pdf-wrap">
					<PdfViewer :pdfurl="pdfurl" />
				</div>
			</el-dialog>
    </div>
</template>
<script>
import PdfViewer from '@/components/PdfViewer.vue';
import axios from 'axios';
export default {
	name: 'index',

	components: {},

	data(){
		return {
			userInfo:{},
			actTab:1,
			num:9999,
			courseList:[],
			collectList:[],
			examList:"",
			ruoList:[],
			isGame:false,
			studyTime:3600,//学习多长时间可以玩游戏
			msgList:[],
			receiverId:'',
			msgText:'',
			msgVisible:false,
			pdfVisible:false,
			pdfurl:'',
			teacherList:"",
			tabList:[
				{
					id:1,
					name:'数学'
				},
				{
					id:2,
					name:'英语'
				},
				{
					id:3,
					name:'物理'
				},
			]
		}
	},
	
	components: {
		PdfViewer,
	},
	
	created(){
		this.getUserInfo();
		this.getRecordDate();
		this.getTeacherList();
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		async init(){
			if(!this.actTab){
				localStorage.removeItem('actTab');
				this.$message('当前没有学习权限，请联系老师');
				return;
			}
			this.getExamList()
			await this.getWeaknessList();
			await this.getCollectList();//获取收藏清单
			await this.getLearnList(true);
			await this.getLearnList(false);
			if(localStorage.getItem('courseHot')||localStorage.getItem('testHot')){//用户产生行为了
				this.getWeakness();//调取清单各项数据
			}else{
				this.getMenuList();//不产生行为直接调取id集合
			}
		},
		getSubject(i){
			this.actTab = i;
			localStorage.setItem('actTab',i);
			this.init();
		},
		async getExamList(){
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				subject:this.actTab,//学科
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				user_id:JSON.parse(localStorage.getItem('userInfo')).qfUserId
			};
			const res = await this.$api.getExamList(jsondata);
			if (res.data.code === 0) {
				this.examList = res.data.data
				console.dir(this.examList)
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getMenuList() {
			let jsondata = {
				type: 1,
				subject:this.actTab
			}
			const res = await this.$api.getMenuList(jsondata);
			if (res.data.success) {
				if(res.data.data.length==0){//集合没数据调取清单数据
					this.getWeakness();
				}else{//有数据用id集合拉取指定知识点
					this.getCourseList({
						idList:res.data.data,//知识点id
					});
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getMenuAdd() {
			let pointIds = this.courseList.map(course => course.point_id);
			let jsondata = {
				type: 1,
				pointIds:pointIds,
				subject:this.actTab
			}
			const res = await this.$api.getMenuAdd(jsondata);
			if (res.data.success) {
				//更新知识点id集合
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeakness(){
			//用清单换知识点
			this.getCourseList({
				ruoList:this.ruoIdList,//个人弱点清单（知识点）
				ruoPublicList:await this.getWeaknessTopList(),//大众弱点清单（知识点）
				collectList:this.collectList,//我的收藏清单（知识点）
				completeList:this.completeList,//完课清单（知识点）
				questionList:this.questionList,//学习记录
				num:this.num,//课数量
			});
		},
		async getWeaknessList() {
			const res = await this.$api.getWeaknessList({
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				subject:this.actTab
			});
			if (res.data.success) {
				this.ruoList = res.data.data;
				this.ruoIdList = res.data.data.map(item => item.pointId);
				this.$forceUpdate();
				console.log('ruoList',this.ruoList)
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeaknessTopList() {
			const res = await this.$api.getWeaknessTopList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,
			});
			if (res.data.success) {
				return res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getLearnList(isComplete){
			const res = await this.$api.getLearnQfList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:1,
				isComplete:isComplete
			});
			if (res.data.success) {
				let resData = [];  // 确保 resData 是一个空数组
				if(isComplete){
					res.data.data.forEach(item => {
					  resData.push(item.pointId);  // 将每个子项的 pointId 推入 this.resData 数组
					});
					this.completeList = resData;
				}else{					
					res.data.data.forEach(item => {
					  // 创建 resData 的单个对象，并设置 point_id
					  const resItem = {
					    point_id: item.pointId,
					    children: []  // 初始化 children 数组
					  };
						item.children = item.children || []
					  // 遍历当前 item 的 children 数组
					  item.children.forEach(child => {
					    resItem.children.push({
					      id: child.businessId,  // 设置 id 为 businessId
					      status: 1  // 设置 status 为 1
					    });
					  });
					
					  // 将构造好的 resItem 推入到 resData 中
					  resData.push(resItem);
						this.questionList = resData;
					});
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getCourseList(actjson) {
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				phone:this.userInfo.accountCode,//手机号
				subject:this.actTab,//学科
				city:this.userInfo.cityId,//城市
				school:this.userInfo.schoolId,//学校
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				user_id:JSON.parse(localStorage.getItem('userInfo')).qfUserId
			};
			const res = await this.$api.getCourseList({...jsondata,...actjson});
			if (res.data.code === 0) {
				this.courseList = res.data.data
				// if(this.actTab==1&&(grades||this.userInfo.gradeClass.split("/")[0])=='高中'){
				// 	this.courseList.unshift({
				// 		point_id:847,
				// 		point_name:'三角函数',
				// 		point_info:'三角函数平移问题',
				// 		qf_url:'ttps://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=372',
				// 		coverImg:'https://view.duofenpai.com/image/default/3450E085CBE84B58B2A85123AEF0C1ED-6-2.png',
				// 	})
				// }
				// localStorage.removeItem('courseHot')
				// localStorage.removeItem('testHot')
				this.getMenuAdd();
				//设置收藏
				if (this.collectList && this.collectList.length > 0) {
				    this.courseList.forEach(course => {
				        if (this.collectList.includes(course.point_id.toString())) {
				            course.isCollect = true;  // 设置收藏
				        }
				    });
				}
				//设置弱点
				if (this.ruoIdList && this.ruoIdList.length > 0) {
				    this.courseList.forEach(course => {
				        if (this.ruoIdList.includes(course.point_id.toString())) {
				            course.ruo = true;  // 设置收藏
				        }
				    });
				}
				
				//设置完成记录
				if (this.completeList && this.completeList.length > 0) {
				    this.courseList.forEach(course => {
				        if (this.completeList.includes(course.point_id.toString())) {
				            course.isComplete = true;  // 设置已完成
				        }
				    });
				}
				
				//设置学习记录
				if (this.questionList && this.questionList.length > 0) {
				    this.questionList.forEach(questionItem => {
				      this.courseList.forEach(courseItem => {
				        if (questionItem.point_id == courseItem.point_id) {
				          courseItem.isContinue = true;
				        }
				      });
				    });
				}
				// 获取 courseList 中 ruo 为 true 的子项，并保持 point_id 为数字
				const ruoTrueOrder = this.courseList
				  .filter(item => item.ruo === true)
				  .map(item => item.point_id); // 保持数字
				
				// 对 ruoList 按 ruoTrueOrder 排序
				this.ruoList.sort((a, b) => {
				  const indexA = ruoTrueOrder.indexOf(Number(a.pointId)); // 转为数字比较
				  const indexB = ruoTrueOrder.indexOf(Number(b.pointId));
				
				  if (indexA === -1) return 1; // 不在排序规则中的，排后面
				  if (indexB === -1) return -1;
				
				  return indexA - indexB; // 按顺序排序
				});

				this.$forceUpdate();
				console.log('courseList',this.courseList)
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async collect(item) {
			let jsondata = {
				pointId:item.point_id,
				type: 1,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				subject:this.actTab
			};
			if(item.isCollect){
				const res = await this.$api.getCollectRemove(jsondata);
				if (res.data.success) {
					this.$message.success('取消收藏成功')
					localStorage.setItem('courseHot',true);
					this.init();
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			}else{
				const res = await this.$api.getCollectAdd(jsondata);
				if (res.data.success) {
					this.$message.success('收藏成功')
					localStorage.setItem('courseHot',true);
					this.init();
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			}
		},
		async getCollectList() {
			const res = await this.$api.getCollectList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type: 1,
			});
			if (res.data.success) {
				this.collectList = res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		goGame(){
			this.$router.push({  //核心语句
			  path:'/game',   //跳转的路径
			  query:{}
			})
		},
		moreCourse(){
			localStorage.setItem('actTab',this.actTab);
			this.$emit('update-active', 1);
			this.$router.push({  //核心语句
			  path:'/course',   //跳转的路径
			  query:{}
			})
		},
		moreExam(){
			this.$emit('update-active', 3);
			this.$router.push({  //核心语句
			  path:'/exam',   //跳转的路径
			  query:{}
			})
		},
		goShiting(){
			this.$router.push({  //核心语句
			  path:'/shiting',   //跳转的路径
			  query:{}
			})
		},
		goCourse(item, fromRuo = false){
			let msg = this.setTab();
			if(msg&&item.point_id!='847'){
				this.$message.warning(msg);
				return;
			}
			localStorage.setItem('actTab',this.actTab);
			this.$emit('update-active', 1);
			localStorage.setItem('routeType','home');
			this.$router.push({  //核心语句
			  path:'/course',   //跳转的路径
			  query:{
					item:JSON.stringify({
						point_id:item.pointId||item.point_id,
						point_name:item.pointName||item.point_name,
						subject:this.actTab,
						fromRuo: fromRuo
					})
				}
			})
		},
		goTest(item){
			let msg = this.setTab();
			if(msg){
				this.$message.warning(msg);
				return;
			}
			localStorage.setItem('actTab',this.actTab);
			this.$emit('update-active', 2);
			localStorage.setItem('routeType','home');
			this.$router.push({  //核心语句
			  path:'/test',   //跳转的路径
			  query:{
					item:JSON.stringify({
						point_id:item.pointId,
						point_name:item.pointName,
						subject:this.actTab,
					})
				}
			})
		},
		goExam(item,t){
			let msg = this.setTab();
			if(msg){
				this.$message.warning(msg);
				return;
			}
			this.$emit('update-active', 3);
			this.$router.push({  //核心语句
			  path:'/exam',   //跳转的路径
			  query:{
					type:'home',
					item:JSON.stringify(item),
					t:t
				}
			})
		},
		async getUserInfo(){//获取用户信息
			// if(JSON.parse(localStorage.getItem("userInfo")).accountCode == "13312345678"){
			// 	this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
			// 	return
			// }
			
			let res = await this.$api.userInfo({});
			
			if (res.data.success) {
				this.userInfo = res.data.data
				localStorage.setItem("userInfo",JSON.stringify(res.data.data))
				// this.setTab();
				this.init();
			}else{
				this.$message.error(res.data.errMsg||res.data.error||res.data.msg||res.data.message);
			}
		},
		// setTab(){
		// 	if(this.userInfo.authIds.indexOf(2)!=-1&&localStorage.getItem("schoolType") == "C"){//初中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(1)!=-1&&localStorage.getItem("schoolType") == "C"){//初中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// 	if(this.userInfo.authIds.indexOf(4)!=-1&&localStorage.getItem("schoolType") == "G"){//高中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(3)!=-1&&localStorage.getItem("schoolType") == "G"){//高中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// },
		setTab(){
			if(!this.userInfo.authIds){
				return '授权时间已过，请联系相关老师开通新的授权。'
			}
			if(this.actTab == 1){
				if(this.userInfo.authIds.indexOf(3)==-1&&localStorage.getItem("schoolType") == "C"){//初中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(4)==-1&&localStorage.getItem("schoolType") == "G"){//高中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 2){
				if(this.userInfo.authIds.indexOf(1)==-1&&localStorage.getItem("schoolType") == "C"){//初中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(2)==-1&&localStorage.getItem("schoolType") == "G"){//高中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 3){
				if(this.userInfo.authIds.indexOf(5)==-1&&localStorage.getItem("schoolType") == "C"){//初中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(6)==-1&&localStorage.getItem("schoolType") == "G"){//高中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}
			return false
		},
		async getClockOpera(status) {
			if(!status){
				return
			}
			const res = await this.$api.getClockOpera();
			if (res.data.success) {
				this.$message.success('打卡成功')
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getRecordDate() {
			const res = await this.$api.getRecordDate();
			if (res.data.success) {
				if(res.data.data>=this.studyTime){
					this.isGame = true;
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		showPdf(pdfurl){
			this.pdfVisible = true;
			this.pdfurl = pdfurl;
		},
		getFileExtension(url) {
			// 使用正则表达式提取文件后缀名
			const extensionMatch = url.match(/\.([^.?]+)(?=[?&]|$)/);
			return extensionMatch ? extensionMatch[1].toLowerCase() : '';
		},
		isFileType(url, type) {
			const ext = this.getFileExtension(url);
			switch (type) {
				case 'pdf':
					return ext === 'pdf';
				case 'img':
					return ['png', 'jpg', 'jpeg', 'gif'].includes(ext);
				case 'video':
					return ['mp4', 'webm', 'ogg'].includes(ext);
				case 'audio':
					return ['mp3', 'wav', 'ogg'].includes(ext);
				default:
					return false;
			}
		},
		async getMessageAdd(receiverId) {
			const res = await this.$api.getMessageAdd({
				content:this.msgText,
				senderId:localStorage.getItem('userCode'),
				receiverId:this.receiverId,
			});
			if (res.data.success) {
				this.getMessageList(this.receiverId);
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getMessageList(receiverId) {
			this.receiverId = receiverId;
			const res = await this.$api.getMessageList({
				current:1,
				pageSize:9999,
				senderId:localStorage.getItem('userCode'),
				receiverId:receiverId,
			});
			if (res.data.success) {
				this.msgList = res.data.data;
				this.$forceUpdate();
				this.$nextTick(() => {
					const scrollContainer = this.$refs.scrollContainer;
					scrollContainer.scrollTop = scrollContainer.scrollHeight;
					this.msgText = "";
				});
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getNoticeList() {
			this.receiverId = -1;
			const res = await this.$api.getNoticeList({
				current:1,
				pageSize:9999,
				nameKeyword: "",
				contentKeyword: "",
			});
			if (res.data.success) {
				this.msgList = res.data.data.records;
				this.$forceUpdate();
				this.$nextTick(() => {
					const scrollContainer = this.$refs.scrollContainer;
					scrollContainer.scrollTop = scrollContainer.scrollHeight;
					this.msgText = "";
				});
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getTeacherList(receiverId) {
			const res = await this.$api.getTeacherList({
				current:1,
				pageSize:9999
			});
			if (res.data.success) {
				this.teacherList = res.data.data.records;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		isDone(url) {
			const regex = /examinee_id=(\d+)/;
			const matches = url.match(regex);
			if (matches && matches[1] && matches[1]!=0) {
				return true
			}else{
				return false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.home-wrap{
	padding: 2rem;
	.top{
		display: flex;
		justify-content: space-between;
		.banner{
			height: 13.8rem;
			border-radius: 0.8rem;
			overflow: hidden;
			width: 58.4rem;
			border-radius: 0.8rem;
			.my-swipe .van-swipe-item {
				img{
					height: 13.8rem;
					width: 58.4rem;
				}
			}
		}
		.card{
			height: 13.8rem;
			width: 35.6rem;
			border-radius: 0.8rem;
			background-image: url('../assets/card.png');
			background-repeat: no-repeat;
			background-size: contain;
			padding: 1.5rem 2rem;
			box-sizing: border-box;
			.head{
				display: flex;
				justify-content: left;
				align-items: center;
				.avator{
					margin-right: 0.6rem;
					img{
						border-radius: 100%;
						width: 4.1rem;
						height: 4.1rem;
					}
				}
				.name{
					font-weight: 500;
					font-size: 1.8rem;
					color: #000000;
					line-height: 1.7rem;
				}
				.qrcode{
					width: 2.4rem;
					height: 2.4rem;
					margin-left: 1rem;
					cursor: pointer;
				}
				.message{
					width: 2.4rem;
					height: 2.4rem;
					margin-left: auto;
					cursor: pointer;
				}
			}
			.cont{
				font-size: 1.2rem;
				color: #000000;
				line-height: 1rem;
				margin: 1rem 0 2.2rem;
			}
			.btn-group{
				display: flex;
				justify-content: space-between;
				align-items: center;
				.game{
					width: 2.4rem;
					height: 2.4rem;
				}
				.gameact{
					cursor: pointer;
					animation: shake 0.5s infinite alternate;
				}
			 /* Keyframes for shaking animation */
				@keyframes shake {
					0% { transform: rotate(-10deg); }
					50% { transform: rotate(10deg); }
					100% { transform: rotate(-10deg); }
				}
				.clockin{
					width: 7.9rem;
					height: 2.6rem;
					background: #ccc;
					border-radius: 0.3rem 0.3rem 0.3rem 0.3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1.2rem;
					color: #fff;
					line-height: 2.6rem;
					text-align: center;
				}
				.isClock{
					background: #FFFFFF;
					color: rgb(100, 45, 113);
					cursor: pointer;
				}
			}
		}
	}
	.subject{
		margin: 1.8rem 0;
		display: flex;
		font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
		font-size: 1.4rem;
		color: #000000;
		line-height: 1.64rem;
		.tab{
			width: 5.5rem;
			height: 2.5rem;
			line-height: 2.5rem;
			text-align: center;
			border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
			margin-right: 5.8rem;
		}
		.actTab{
			background: rgb(100, 45, 113);
			color: #fff;
		}
	}
}
.main{
	display: flex;
	justify-content: space-between;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.course-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.course-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
	}
	.course-list{
		width: 58.4rem;
		.course-cont{
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			.course-card{
				width: 18.35rem;
				height: 14.45rem;
				background: #FFFFFF;
				margin-bottom: 1.5rem;
				border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
				overflow: hidden;
				.course-bg{
					width: 18.35rem;
					height: 7.5rem;
					background-repeat: no-repeat;
					background-size: cover;
					position: relative;
					.course-study{
						position: absolute;
						top: 0.75rem;
						left: 0.75rem;
						width: 4.35rem;
						height: 1.8rem;
						background: rgba(141,51,0,0.77);
						border-radius: 3rem 3rem 3rem 3rem;
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-size: 0.8rem;
						color: rgb(100, 45, 113);
						line-height: 1.8rem;
						text-align: center;
					}
					.course-ruo{
							position: absolute;
							right: 0;
							top: 0;
							width: 2.45rem;
							height: 2.05rem;
					}
				}
				.course-name{
					margin: 0.75rem 0.9rem 0.6rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.2rem;
					color: #1D1D1D;
					line-height: 1rem;
				}
				.course-text{
					margin: 0 0.9rem 0.5rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: #74798C;
					line-height: 1rem;
					height: 2rem;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					/*! autoprefixer: off */
					-webkit-box-orient: vertical;

				}
				.course-btn{
					display: flex;
					align-items: center;
					justify-content: flex-start;
					margin: 0 0.9rem;
					.course-avator{
						width: 1.2rem;
						height: 1.2rem;
						border-radius: 6rem;
						margin-right: 0.4rem;
					}
					.course-teacher{
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-size: 0.8rem;
						color: #1D1D1D;
						line-height: 1.12rem;
					}
					.course-save{
						background-image: url('../assets/heart-1.png');
						background-repeat: no-repeat;
						background-size: contain;
						width: 1.2rem;
						height: 1.2rem;
						margin-left: auto;
					}
					.course-save-act{
						background-image: url('../assets/heart.png');
					}
				}
			}
		}
	}
	.right{
		width: 35.6rem;
		.exam-list{
			margin-bottom: 2rem;
			height: 16rem;
			.exam-item{
				width: 35.6rem;
				box-sizing: border-box;
				padding: 0.75rem 1rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				background: #FFFFFF;
				border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
				margin-bottom: 0.6rem;
				.exam-name{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1rem;
					color: #1D1D1D;
					line-height: 1.4rem;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					flex:1;
				}
				.exam-time{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: #1D1D1D;
					line-height: 1.12rem;
					display: flex;
					.btn{
						border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
						padding: 5px 10px;
						height: 2rem;
						border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
						border: 0.05rem solid #642d71;
						color: #642d71;
						display: flex;
						justify-content: center;
						align-items: center;
						padding: 0 0.75rem;
						margin-left: 1.5rem;
						.test-list-icon{
							width: 1rem;
							height: 1rem;
							background-repeat: no-repeat;
							background-size: contain;
							margin-right: 0.5rem;
						}
						.reading-icon-no{
							background-image: url(../assets/reading-icon-no.png);
						}
						.reading-icon{
							background-image: url(../assets/reading-icon.png);
						}
					}
					.btn-ok{
						background: #642d71;
						color: #fff;
					}
					img{
						width: 1rem;
					}
				}
			}
		}
		.ruo-list{
			height: 15rem;
			overflow-y: auto;
			.ruo-item{
				display: flex;
				justify-content: flex-end;
				align-items: center;
				margin-bottom: 0.6rem;
				box-sizing: border-box;
				padding: 0.75rem 1rem;
				background: #FFFFFF;
				border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
				.ruo-name{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1rem;
					color: #1D1D1D;
					line-height: 1.4rem;
					margin-right: auto;
				}
				.ruo-btn{
					width: 7.65rem;
					height: 2rem;
					border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
					border: 0.05rem solid rgb(100, 45, 113);
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					display: flex;
					align-items: center;
					justify-content: center;
					margin-left: 1.5rem;
					img{
						width: 1rem;
						height: 1rem;
						margin-right: 0.5rem;
					}
				}
			}
		}
	}
}
.msg-wrap{
	display: flex;
	.teacher-cont{
		border: 1px solid rgb(231, 231, 231);
		width: 7.5rem;
		height: 24rem;
		margin-right: 0.05rem;
		background-color: rgb(245, 245, 245);
		overflow: auto;
		.teacher-item{
			width:100%;
			box-sizing: border-box;
			padding: 1rem;
			display: flex;
			align-items: center;
			cursor: pointer;
			border-bottom: 1px solid rgb(251, 251, 251);
			.new{
				color: #ff0000;
				margin-left: 1rem;
			}
		}
		.teacher-item-act{
			background-color: rgb(100, 45, 113);
			color: #fff;
		}
	}
	.msg-cont{
		padding: 1rem;
		border: 1px solid rgb(231, 231, 231);
		height: 24.1rem;
		box-sizing: border-box;
		overflow: auto;
		background-color: rgb(245, 245, 245);
		flex:1;
		.msg-item{
			width:100%;
			display: flex;
			margin-bottom: 1rem;
			.avator{
				background-repeat: no-repeat;
				background-size: contain;
			}
			.message{
				max-width: 15rem;
				background-color: #fff;
				padding: 0.5rem;
				border-radius: 4px;
				box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
			}
			.timestamp{
				font-size: 10px;
				margin-top: 5px;
			}
			.media-message{
				background-color: #fff;
				padding: 10px;
				border-radius: 4px;
				box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
			}
		}
		.msg-teacher{
			justify-content: flex-start;
			.avator{
				width: 2rem;
				height: 2rem;
				margin-right: 0.5rem;
				background-image: url(../assets/teacher.png);
			}
			.timestamp{
				text-align: left;
			}
			.sys-avator{
				background-image: url(../assets/sys.png);
			}
		}
		.msg-student{
			justify-content: flex-end;
			.avator{
				width: 2rem;
				height: 2rem;
				order:1;
				border-radius: 100%;
				margin-left: 0.5rem;
				// background-image: url(../assets/student.png);
			}
			.timestamp{
				text-align: right;
			}
		}
	}
}
.dialog-footer{
	display: flex;
	.msgText{
		margin-right: 10px;
	}
	.enter{
		background-color: rgb(100, 45, 113);
		border: 1px solid rgb(100, 45, 113);
	}
}
::v-deep .el-dialog__body{
	padding: 10px 20px 0;
}
.el-icon-folder-opened{
	margin-right: 5px;
	font-size: 24px;
	padding: 0 10px;
}
.elbtn{
	width: 75px;
}
.media-item{
	width: 250px;
}
.pdf-wrap{
	height: 700px;
	overflow: auto;
}
</style>
